// extracted by mini-css-extract-plugin
export default {"sectionTitle":"sectionTitle-TQhb_"};